<div class="na-page">
  <div class="na-card">
    <h1 class="na-title">{{ 'Kein Zugriff' | translate }}</h1>
    <p class="na-text">{{ 'Dir fehlt der Zugriff auf nextPIM.' | translate }}</p>
    <dx-button text="{{ 'Abmelden' | translate }}" type="default" width="100%" (onClick)="logout()"></dx-button>
  </div>
</div>
